export const mapProduct = (item, index) => {
    const hasBalance = (item.balance !== undefined && item.balance !== null) || (item.BALANCE !== undefined && item.BALANCE !== null);
    const balance = hasBalance ? (item.balance !== undefined ? Number(item.balance) : Number(item.BALANCE)) : undefined;
    const favprd = item.favprd || item.FAVPRD || 0;
    const prate = item.prate !== undefined ? item.prate : (item.PRATE !== undefined ? item.PRATE : undefined);
    const salrate = item.salrate || item.SALRATE || item.sale_rate || item.SALE_RATE || item.price || item.PRATE || item.PMRP || 0;
    const valance = item.valance !== undefined ? item.valance : (item.VALANCE !== undefined ? item.VALANCE : undefined);
    
    return {
        ...item,
        id: item.prd_code || item.PRD_CODE || item.code || index,
        name: item.prd_name || item.PRD_NAME || item.name || "Product",
        code: item.prd_code || item.PRD_CODE || item.code,
        description: item.prddesc || item.PRDDESC || item.description || "No description available",
        price: salrate,
        salrate: salrate,
        prate: prate,
        valance: valance,
        status: hasBalance ? (balance > 0 ? "In Stock" : "Out of Stock") : "In Stock",
        balance: balance,
        isLiked: favprd === 1,
        isInCart: (item.cartqty || item.CARTQTY || 0) > 0,
        image: item.image1 || item.IMAGE1 || item.img || item.image || "https://via.placeholder.com/300",
        images: [
            item.image1 || item.IMAGE1,
            item.image2 || item.IMAGE2,
            item.image3 || item.IMAGE3
        ].filter(Boolean),
        sku: item.prd_code || item.PRD_CODE || item.code,
        color: item.color || item.COLOR || "N/A",
        material: item.material || "N/A",
        transparency: item.transparency || "N/A",
        category: item.category || item.CATEGORY,
        subcatg: item.subcatg || item.SUBCATG,
        catgid: item.catgid || item.CATGID,
        subcatgid: item.subcatgid || item.SUBCATGID
    };
};
